import { PageController } from '@client/components/_core/layout/PageController';
import { PublicNoIndex } from '@client/components/_shared/public/PublicNoIndex';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PasswordResetForm } from './PasswordResetForm';
import { passwordResetSearchSchema } from './password-reset-search';

export const Route = createFileRoute('/password-reset/reset')({
    validateSearch: zodValidator(passwordResetSearchSchema),
    component: PasswordResetRoute,
});

function PasswordResetRoute() {
    return (
        <PageController route={Route}>
            <PublicNoIndex />
            <PasswordResetForm search={Route.useSearch()} />
        </PageController>
    );
}
